<footer class="app-footer-v2">
  <div class="container-fluid-lg">
    <div class="app-footer-v2__surface">
      <div class="app-footer-v2__top">
        <div class="row g-3 g-lg-4">
          <div class="col-xl-3 col-lg-6 col-md-6">
            <section class="footer-block footer-brand">
              <a class="footer-brand__logo" [routerLink]="['/home']">
                <picture>
                  <source srcset="assets/logo/header3.webp" type="image/webp">
                  <img
                    src="assets/logo/header3.png"
                    class="img-fluid"
                    alt="{{ 'auto_logo' | translate }}"
                    width="448"
                    height="62"
                  />
                </picture>
              </a>

              <div class="footer-brand__content">
                <p class="footer-brand__title">{{ "footer_title" | translate }}</p>
                <p>{{ "footer_description_1" | translate }}</p>
                <p>{{ "footer_description_2" | translate }}</p>
                <p>{{ "footer_description_3" | translate }}</p>
              </div>
            </section>
          </div>

          <div class="col-xl-3 col-lg-6 col-md-6">
            <section class="footer-block">
              <div class="footer-links-grid">
                <div class="links">
                  <h4 class="footer-block__title">{{ "menu" | translate }}</h4>
                  <ul>
                    <li>
                      <a routerLink="/home">{{ "menu_home" | translate }}</a>
                    </li>
                    <li>
                      <a routerLink="/creators">{{ "menu_streamers" | translate }}</a>
                    </li>
                  </ul>
                </div>

                <div class="links">
                  <h4 class="footer-block__title">{{ "help_center" | translate }}</h4>
                  <ul>
                    <li>
                      <a routerLink="/faq">{{ "faq_title" | translate }}</a>
                    </li>
                    <li>
                      <a routerLink="/terms-and-conditions">{{ "terms_and_conditions" | translate }}</a>
                    </li>
                    <li>
                      <a routerLink="/privacy-policy">{{ "privacy_policy_short" | translate }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </div>

          <div class="col-xl-3 col-lg-6 col-md-6">
            <section class="footer-block">
              <h4 class="footer-block__title">{{ "contact_us" | translate }}</h4>
              <ul class="footer-contact">
                <li class="footer-contact__item">
                  <mat-icon class="footer-contact__icon">mail_outline</mat-icon>
                  <p>
                    <strong>{{ "email_address" | translate }}:</strong>
                    {{ "auto_support_thecoolrhyno_com" | translate }}
                  </p>
                </li>
                <li class="footer-contact__item">
                  <mat-icon class="footer-contact__icon">support_agent</mat-icon>
                  <p>
                    <strong>{{ "customer_service_title" | translate }}:</strong>
                    {{ "customer_service_description" | translate }}
                  </p>
                </li>
              </ul>
            </section>
          </div>

          <div class="col-xl-3 col-lg-6 col-md-6">
            <section class="footer-block">
              <h4 class="footer-block__title">{{ "social_media" | translate }}</h4>
              <div class="social-row">
                @for (social of socialLinks; track social.href) {
                  <a
                    [href]="social.href"
                    class="social-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                    [attr.aria-label]="social.altKey | translate"
                  >
                    <img [src]="social.icon" [alt]="social.altKey | translate" />
                  </a>
                }
              </div>

              <div class="footer-social-copy">
                <p>{{ "footer_social_media_description_1" | translate }}</p>
                <p>{{ "footer_social_media_description_2" | translate }}</p>
                <p>{{ "footer_social_media_description_3" | translate }}</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <div class="app-footer-v2__bottom">
        <p class="footer-copyright">{{ "footer_social_media_description_4" | translate }}</p>
        <p class="footer-version">v{{ appVersion }} • {{ buildDate | date: "dd/MM/yyyy" }}</p>
      </div>
    </div>
  </div>
</footer>
